import * as React from 'react';
import AccountSwitcher from 'owa-account-switcher';
import { isFeatureEnabled } from 'owa-feature-flags';
import { MultiAccountSwitcher } from 'owa-multi-account-switcher';
import { isMultiAccountScenario } from 'owa-left-rail-utils';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isEdu } from 'owa-nonboot-userconfiguration-manager';
import { Module } from 'owa-bootstrap';
import { OverflowSet, IOverflowSetItemProps } from '@fluentui/react/lib//OverflowSet';
import { getAllOfficeAppItems, getAllModuleSwitcherItems } from 'owa-left-rail-utils';
import AppDrawerButton from './AppDrawerButton';
import LeftRailItem from './LeftRailItem';

let styles = require('./LeftRail.scss');
let classNames = require('classnames/bind').bind(styles);

export interface LeftRailProps extends React.HTMLAttributes<HTMLDivElement> {
    selectedModule: Module;
    /**
     * The action to call when the item is clicked and it also represents the active module.
     * - (eg, clicking mail while in mail)
     */
    activeModuleAction?: (
        ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>
    ) => void;
}

export default function LeftRail(props: LeftRailProps) {
    const { selectedModule, activeModuleAction } = props;

    const getLeftRailItems = React.useCallback(() => {
        return shouldShowOfficeAppRail(selectedModule)
            ? getAllModuleSwitcherItems(selectedModule).concat(getAllOfficeAppItems(false))
            : getAllModuleSwitcherItems(selectedModule);
    }, [selectedModule]);

    const renderItem = React.useCallback(
        (item: IOverflowSetItemProps) => {
            if (item.isAppDrawerItem) {
                return <AppDrawerButton />;
            } else {
                return (
                    <LeftRailItem
                        iconProps={item.iconProps}
                        item={item.workload}
                        text={item.text}
                        isSelected={item.isSelected}
                        isHorizontal={false}
                        href={item.href}
                        onClick={item.onClick}
                        disabled={false}
                        openInNewTab={item.openInNewTab}
                    />
                );
            }
        },
        [selectedModule]
    );

    return (
        <div
            className={classNames(
                styles.leftRail,
                !isFeatureEnabled('tri-metaOsRail') && styles.bottomButtons,
                isFeatureEnabled('tri-metaOsRail') && styles.metaOsBg
            )}>
            {isFeatureEnabled('auth-cloudCache') && <AccountSwitcher />}
            {isMultiAccountScenario() && selectedModule == Module.Mail && (
                <MultiAccountSwitcher activeAccountAction={activeModuleAction} />
            )}
            <OverflowSet
                vertical={true}
                items={getLeftRailItems()}
                onRenderItem={renderItem}
                onRenderOverflowButton={null}
            />
        </div>
    );
}

function shouldShowOfficeAppRail(selectedModule: Module): boolean {
    // The office app rail should only show when the flight is turned on
    // and if it's a consumer user or in case of enterprise if it's EDU user.
    // OR if the metaOs flight is on and the user is in the mail or calendar module
    return (
        (isFeatureEnabled('tri-metaOsRail') &&
            (selectedModule === Module.Mail || selectedModule === Module.Calendar)) ||
        ((isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment1') ||
            isFeatureEnabled('sig-LeftNavOfficeButtonsTreatment2')) &&
            (isConsumer() || isEdu()))
    );
}
